import { useQuery } from 'react-query';

import API from '../../constants/API';
import axios from '../../constants/axios';
import useSimpleLoading from '../useSimpleLoading';

const useDiscussion = (id) => {
  const { onLoading, onLoadingEnd, onError } = useSimpleLoading();

  return useQuery(
    ['discussion', `${id}`],
    async () => {
      onLoading();
      const { data } = await axios.get(`${API.getDiscussion}/${id}`);
      return data;
    },
    {
      onSettled: onLoadingEnd,
      onError: (e) => {
        if (e.status !== 'fail') {
          onError(e);
        }
      },
      enabled: !!id,
    },
  );
};

export default useDiscussion;
